import { AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { isEmptyArray, isEmptyObject, isStringEmpty, parseEmptyArray, scrollToElement } from '@common/helpers';
import {
  LANGUAGE_JP,
  LOCATION_CODOE_NGO,
  LUFTHANSA,
  POS_COUNTRY_CODE_JP,
} from '@common/helpers/constants/my-booking/my_booking_service.contant';
import { MybookingServiceState } from '@common/interfaces/mybooking/mybooking-service.interface';
import { ChargeableLounge, FirstBaggage, MealInformation } from '@common/interfaces/mybooking/mybooking.interface';
import {
  CallCenterRequestBaggage,
  FirstBaggagePassengerMap,
  FirstBaggagePnr,
} from '@common/interfaces/mybooking/order-baggage.interface';
import {
  JuniorPilot,
  Lounge,
  Meal,
  MyCarValet,
  PassengerJuniorPilotMap,
  PassengerLoungeMap,
  PassengerRegisteredPetsMap,
  PetService,
  ServiceSupport,
  TravelerMealInfo,
} from '@common/interfaces/mybooking/order-services.interface';
import { SeatReservationStatus } from '@common/interfaces/servicing-seatmap/seat-reservation-status';
import { ServicingCommonStoreService } from '@common/services';
import { MyBookingServiceService } from '@common/services/my-booking/my-booking-service/my-booking-service.service';
import { MyBookingStoreService } from '@common/services/my-booking/my-booking-store.service';
import { MyBookingService } from '@common/services/my-booking/my-booking.service';
import { SupportComponent } from '@lib/components/support-class';
import { DeviceType } from '@lib/interfaces';
import { CommonLibService, SystemDateService } from '@lib/services';
import { BehaviorSubject, Subject, Subscription, combineLatest, debounceTime, delay, takeUntil } from 'rxjs';
import {
  Bound,
  GetOrderResponseData,
  GetOrderResponseDataAir,
  OrderSeatItemSeatSelection,
  Traveler,
  Type1,
} from 'src/sdk-servicing';

@Component({
  selector: 'asw-my-booking-service-pres',
  templateUrl: './my-booking-service-pres.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyBookingServicePresComponent extends SupportComponent implements AfterViewChecked {
  private readonly _subscriptions: Subscription = new Subscription();
  isTheLastViewChecked$ = new BehaviorSubject(false);
  // 提携：スクロール処理が実行されたかどうかのBoolean
  isscrolled$ = new Subject();
  /** 注文応答データの取得 */
  pnr!: GetOrderResponseData;

  flights!: Array<Type1>;

  chargeableLounge!: ChargeableLounge;
  seatReservationStatus!: SeatReservationStatus;
  isExistLounge: boolean = false;
  isExistMyCarVaLet: boolean = false;

  // Show service area
  isCheckInServiceApplication!: boolean;
  isExistSeatService: boolean = false;
  isExistLoungeService: boolean = false;
  isExistMyCarValetService: boolean = false;
  isExistPetService: boolean = false;
  isExistCallCenterApplicationBaggageService: boolean = false;
  isExistFirstBaggageService: boolean = false;
  isExistMealService: boolean = false;
  isExistJuniorPilotService: boolean = false;
  isExistSupportService: boolean = false;
  isExistSeatServiceInPNR: boolean = false;

  firstBaggage!: FirstBaggage;
  meal!: MealInformation;
  travelers!: Traveler;
  seatFlightInforList: Array<Type1> = [];
  seatPassengerInforList: Array<Traveler> = [];
  flightsByUN: Array<Type1> = [];
  travelersByINF: Array<Traveler> = [];
  firstBaggageBoundInforList: Array<Bound> = [];
  firstBaggagePassengerInforList: Array<Traveler> = [];
  callCenterBaggageFlightInforList: Array<Type1> = [];
  callCenterBaggagePassengerInforList: Array<Traveler> = [];
  myCarValetFlightInforList: Array<Type1> = [];
  myCarValetPassengerInforList: Array<Traveler> = [];
  juniorPilotFlightInforList: Array<Type1> = [];
  mealFlightInforList: Array<Type1> = [];
  mealPassengerInforList: Array<Traveler> = [];
  loungeFlightInforList: Array<Type1> = [];
  loungePassengerInforList: Array<Traveler> = [];
  attendFlightInforList: Array<Type1> = [];
  supportFlightInforList: Array<Type1> = [];
  supportPassengerInforList: Array<Traveler> = [];

  constructor(
    private readonly _common: CommonLibService,
    public change: ChangeDetectorRef,
    private readonly _myBookingServiceService: MyBookingServiceService,
    private readonly _myBookingStoreService: MyBookingStoreService,
    private readonly _servicingCommonStoreService: ServicingCommonStoreService,
    private readonly _myBookingService: MyBookingService,
    private readonly _elementRef: ElementRef,
    private readonly _systemDateSvc: SystemDateService
  ) {
    super(_common);
  }

  init(): void {
    this._subscriptions.add(
      this._servicingCommonStoreService.getServicingCommonModel$().subscribe((servicingCommon) => {
        this.chargeableLounge = servicingCommon.chargeableLounge ?? ({} as ChargeableLounge);
        this.seatReservationStatus = servicingCommon.seatReservationStatus ?? {};
        this.meal = servicingCommon?.meal ?? ({} as MealInformation);
        this.pnr = servicingCommon.getOrder ?? ({} as GetOrderResponseData);
      })
    );
    this._subscriptions.add(
      this._myBookingServiceService.mybookingServiceState$.subscribe((state) => {
        this.isExistSeatService = false;
        this.isExistPetService = false;
        this.isExistJuniorPilotService = false;
        this.isExistSeatServiceInPNR = false;
        this.saveDataFromMyBookingServiceState(state);

        this.juniorPilotFlightInforList = state.juniorPilotFlightInforList ?? [];
        this.isExistLounge = this.onHandleDisplayLoungeInfor();
        this.isExistMyCarValetService = this.onHandleDisplayMyCarValetInfor();
        this.isExistFirstBaggageService = this.onHandleShowHideFirstBaggageService();
        this.isExistCallCenterApplicationBaggageService = this.onHandleShowHideCallCenterApplicationBaggageService();
        this.isExistLoungeService = this.onHandleDisplayLoungeInfor();
        this.isExistMealService = this.onHandleDisplayMeal();
        this.isExistSupportService = this.onHandleDisplaySupport();
        this.onHandleShowHideService();

        this._myBookingServiceService.myBookingServiceShowHideState$.next({
          isExistCallCenterApplicationBaggageService: this.isExistCallCenterApplicationBaggageService,
          /**
           * [1.4] 事前追加手荷物情報
           * (3)「事前追加手荷物」ボタン押下処理 item 3.1
           */
          isExistFirstBaggageService: this.isExistFirstBaggageService,
          // [2.2] 事前座席指定情報
          isExistSeatService: this.isExistSeatService,
          /**
           * [1.6] ラウンジ情報
           * (4)「ラウンジ」ボタン押下処理 item 4.1
           */
          isExistLoungeService: this.isExistLoungeService,
          /**
           * [1.9] マイカーバレー情報
           * [2.9] マイカーバレー情報
           * (7)「マイカーバレー」ボタン押下処理 item 7.1
           */
          isExistMyCarValetService: this.isExistMyCarValetService,
          /**
           * [1.7] 機内食情報
           * (5)「機内食」ボタン押下処理 item 5.1
           */
          isExistMealService: this.isExistMealService,
          /**
           * [1.8] ペットらくのり
           * [2.10] 申込状況
           * (23)「ペットらくのり申込」ボタン押下処理 item 23.1
           */
          isExistPetService: this.isExistPetService,
          /**
           * [1.10] ジュニアパイロット情報
           * [2.6] 申込状況
           * (24) 「ジュニアパイロット申込」ボタン押下処理 item 24.1
           */
          isExistJuniorPilotService: this.isExistJuniorPilotService,
          // [2.12] 配慮系サポート
          isExistSupportService: this.isExistSupportService,
          isExistLounge: this.isExistLounge,

          myCarValetDomestic: this.isMyCarValetDomestic(),
          myCarValetInternational: this.isMyCarValetInternational(),
        });
        this.change.markForCheck();
      })
    );
    this._subscriptions.add(
      this._myBookingStoreService.getMyBookingModel$().subscribe((state) => {
        this.isCheckInServiceApplication = state.checkInServiceApplication ?? false;
        this.change.markForCheck();
      })
    );

    // 提携：ほか画面から当画面に戻ってきていない場合、処理をしないように修正
    if (this._myBookingService.positionScrollId$.value !== '') {
      this._subscriptions.add(
        combineLatest([
          this._myBookingService.positionScrollId$,
          this.isTheLastViewChecked$,
          this._myBookingService.isApiCallMyBookingCompleted$,
        ])
          .pipe(delay(1000))
          // 提携：スクロール処理が走ったのち、SubScribe処理に入らないように修正
          .pipe(takeUntil(this.isscrolled$))
          .subscribe(([positionScrollId, isTheLastViewChecked, isApiCallMyBookingCompleted]) => {
            if (positionScrollId && isTheLastViewChecked && isApiCallMyBookingCompleted) {
              const isDomExist = this?._elementRef.nativeElement.querySelector(`#${positionScrollId}`);
              if (isDomExist) {
                scrollToElement(positionScrollId);
                this._myBookingService.positionScrollId$.next('');
                this.isscrolled$.next(true);
              }
            }
          })
      );
    }
  }

  private saveDataFromMyBookingServiceState(state: MybookingServiceState): void {
    this.pnr = state.pnr ?? ({} as GetOrderResponseData);
    this.flights = state.flights ?? [];
    this.flightsByUN = state.flightsByUN ?? [];
    this.travelersByINF = state.travelersByINF ?? [];

    this.saveBaggageState(state);

    this.seatFlightInforList = state.seatFlightInforList ?? [];
    this.seatPassengerInforList = state.seatPassengerInforList ?? [];

    this.saveServiceState(state);

    this.attendFlightInforList = state.attendFlightInforList ?? [];
    this.supportFlightInforList = state.supportFlightInforList ?? [];
    this.supportPassengerInforList = state.supportPassengerInforList ?? [];
  }

  private saveBaggageState(state: MybookingServiceState) {
    this.firstBaggage = state.firstBaggage ?? {};
    this.firstBaggageBoundInforList = state.firstBaggageBoundInforList ?? [];
    this.firstBaggagePassengerInforList = state.firstBaggagePassengerInforList ?? [];
    this.callCenterBaggageFlightInforList = state.callCenterBaggageFlightInforList ?? [];
    this.callCenterBaggagePassengerInforList = state.callCenterBaggagePassengerInforList ?? [];
  }

  private saveServiceState(state: MybookingServiceState) {
    this.myCarValetFlightInforList = state.myCarValetFlightInforList ?? [];
    this.myCarValetPassengerInforList = state.myCarValetPassengerInforList ?? [];
    this.mealFlightInforList = state.mealFlightInforList ?? [];
    this.mealPassengerInforList = state.mealPassengerInforList ?? [];
    this.loungeFlightInforList = state.loungeFlightInforList ?? [];
    this.loungePassengerInforList = state.loungePassengerInforList ?? [];
  }

  /**
   * Optimization loop of these Services that using variables flightsByUN and travelersByINF in init event.
   * 事前座席指定セグメント情報リスト và 事前座席指定搭乗者情報リスト(seatFlightInforList, seatPassengerInforList)
   * ペットらくのりセグメント情報リスト và ペットらくのり搭乗者情報リスト(petRakunoriFlightInforList, petRakunoriPassengerInforList)
   * ジュニアパイロットセグメント情報リスト và ジュニアパイロット搭乗者情報リスト(juniorPilotFlightInforList, juniorPilotPassengerInforList)
   */
  onHandleShowHideService(): void {
    // 事前座席指定セグメント情報リスト
    for (const flight of this.seatFlightInforList) {
      for (const traveler of this.travelersByINF) {
        if (!this.isExistSeatService) {
          this.isExistSeatService = this.onHandleDisplayAdvanceSeatReservationInfor(flight, traveler);
        }
      }
    }
    // ジュニアパイロットセグメント情報リスト
    for (const flight of this.juniorPilotFlightInforList) {
      for (const traveler of this.travelersByINF) {
        if (!this.isExistJuniorPilotService) {
          this.isExistJuniorPilotService = this.onHandleDisplayJuniorPilot(flight, traveler);
        }
      }
    }
    for (const flight of this.flightsByUN) {
      for (const traveler of this.travelersByINF) {
        if (!this.isExistSeatServiceInPNR) {
          this.isExistSeatServiceInPNR = this.onHandleCheckExistSeatServiceInPnr(flight, traveler);
        }
        if (!this.isExistPetService) {
          this.isExistPetService = this.onHandleDisplayPet(flight, traveler);
        }
      }
    }
  }

  onHandleShowHideFirstBaggageService(): boolean {
    // 1.2.PNR情報取得API応答.data.services.baggage.firstBaggageが存在する　かつ、　PNR情報取得API応答.data.services.baggage.firstBaggage.＜当該セグメント情報事前追加手荷物バウンド情報.id＞.<当該事前追加手荷物搭乗者情報.id>.id""(空欄）) の一つ要素が存在する
    return this.firstBaggageBoundInforList.some((bound) => {
      return this.firstBaggagePassengerInforList.some((traveler) => {
        const firstBaggage = this.pnr?.services?.baggage?.firstBaggage as FirstBaggagePnr;
        const firstBaggagePassengerMap = firstBaggage?.[String(bound.airBoundId)]?.[
          String(traveler.id)
        ] as FirstBaggagePassengerMap;
        return isEmptyObject(firstBaggagePassengerMap) !== true && !isStringEmpty(firstBaggagePassengerMap?.id);
      });
    });
  }

  onHandleShowHideCallCenterApplicationBaggageService(): boolean {
    /**
     * PNR情報取得API応答.data.services.baggage.callCenterRequestBaggageが存在する、
     * かつPNR情報取得API応答.data.services.baggage.callCenterRequestBaggage.＜当該コールセンター申込手荷物セグメント情報.id＞.<当該コールセンター申込手荷物搭乗者情報.id>.serviceStatus≠（"cancelled"(取り消し) かつ、""(空欄）)の一つ要素が存在する場合
     */
    if (isEmptyArray(this.callCenterBaggageFlightInforList)) {
      return false;
    }
    return this.callCenterBaggageFlightInforList.some((flight) => {
      return this.callCenterBaggagePassengerInforList.some((traveler) => {
        const callCenterRequestBaggage = this.pnr?.services?.baggage
          ?.callCenterRequestBaggage as CallCenterRequestBaggage;
        const centerRequestBaggagePassengerInfors =
          callCenterRequestBaggage?.[String(flight.id)]?.[String(traveler.id)];
        return (centerRequestBaggagePassengerInfors as any).some((centerRequestBaggagePassengerInfor: any) => {
          return (
            isEmptyObject(centerRequestBaggagePassengerInfor) !== true &&
            isStringEmpty(centerRequestBaggagePassengerInfor?.serviceStatus) !== true &&
            centerRequestBaggagePassengerInfor?.serviceStatus !== CallCenterRequestBaggage.ServiceStatusEnum.Cancelled
          );
        });
      });
    });
  }

  onHandleDisplayLoungeInfor(): boolean {
    return this.loungeFlightInforList.some((flight) => {
      return this.loungePassengerInforList.some((traveler) => {
        const lounge = this.pnr?.services?.lounge as Lounge;
        const passengerLounge = lounge?.[String(flight?.id)]?.[String(traveler.id)] as PassengerLoungeMap;
        return (
          isEmptyObject(passengerLounge) !== true &&
          (isStringEmpty(passengerLounge?.serviceStatus) !== true || passengerLounge?.isMyLoungeRequested === true)
        );
      });
    });
  }

  onHandleDisplayJuniorPilot(flight?: Type1, traveler?: Traveler): boolean {
    /**
     * PNR情報取得API応答.data.services.juniorPilotが存在する　かつ、
     * PNR情報取得API応答.data.services.juniorPilot.＜ジュニアパイロットセグメント情報.id＞.<ジュニアパイロット搭乗者情報.id>.serviceStatus≠（""notRequested""(未申込)かつ、""""(空欄）) の一つ要素が存在する場合、申込済みの旨
     */
    // 提携:　PNR情報取得API応答.data.orderEligibilities.juniorPilot.isEligibleToForward = true(ジュニアパイロット申込の案内要否が要)の場合も表示する　※OR条件として追加
    const juniorPilot = this.pnr?.services?.juniorPilot as JuniorPilot;
    const passengerJuniorPilotMap = juniorPilot?.[String(flight?.id)]?.[String(traveler?.id)];
    return (
      this.pnr?.orderEligibilities?.juniorPilot?.isEligibleToForward ||
      (isEmptyObject(passengerJuniorPilotMap) !== true &&
        isStringEmpty(passengerJuniorPilotMap?.serviceStatus) !== true &&
        passengerJuniorPilotMap?.serviceStatus !== PassengerJuniorPilotMap.ServiceStatusEnum.NotRequested)
    );
  }

  onHandleDisplaySupport(): boolean {
    // PNR情報取得API応答.data.services.serviceSupport.搭乗者情報ID.specialServiceRequests≠[]場合、搭乗者(席なし幼児を除く)及びセグメント毎に表示する。
    return this.supportPassengerInforList.some((traveler) => {
      const serviceSupport = this.pnr?.services?.serviceSupport as ServiceSupport;
      return !isEmptyArray(serviceSupport?.[String(traveler.id)]?.specialServiceRequests);
    });
  }

  onHandleDisplayMyCarValetInfor(): boolean {
    /**
     * PNR情報取得API応答.data.services.myCarvaletが存在する　かつ、
     * PNR情報取得API応答.data.services.myCarvalet.＜当該マイカーバレーセグメント情報.id＞.<当該マイカーバレー搭乗者情報.id>.isRequested=true(申込済)の一つ要素が存在する場合
     */
    return this.myCarValetFlightInforList.some((flight) => {
      return this.myCarValetPassengerInforList.some((traveler) => {
        const myCarValet = this.pnr?.services?.myCarValet as MyCarValet;
        return (
          isEmptyObject(myCarValet) !== true &&
          Boolean(myCarValet?.[String(flight.id)]?.[String(traveler.id)]?.isRequested)
        );
      });
    });
  }

  onHandleDisplayAdvanceSeatReservationInfor(flight?: Type1, traveler?: Traveler): boolean {
    /**
     * PNR情報取得API応答.data.seats.＜事前座席指定セグメント情報.id＞.<事前座席指定搭乗者情報.id>が存在する、
     * かつPNR情報取得API応答.data.seats.＜当該事前座席指定セグメント情報.id＞.<当該事前座席指定搭乗者情報.id>.serviceStatus≠（"cancelled"(取り消し)かつ、""(空欄）)の一つ要素が存在する
     */
    const seat = this._myBookingServiceService.getSeatItemPnr(this.pnr, flight?.id, traveler?.id);
    return (
      isEmptyObject(seat?.seatSelection) !== true &&
      isStringEmpty(seat?.seatSelection?.serviceStatus) !== true &&
      seat?.seatSelection?.serviceStatus !== OrderSeatItemSeatSelection.ServiceStatusEnum.Cancelled
    );
  }

  onHandleCheckExistSeatServiceInPnr(flight?: Type1, traveler?: Traveler): boolean {
    const seat = this._myBookingServiceService.getSeatItemPnr(this.pnr, flight?.id, traveler?.id);
    const seatSelection = seat?.seatSelection;

    // [1.2.1.2]
    const condition1 =
      // (PNR情報取得API応答.data.seats.＜事前座席指定セグメント情報.id＞.<事前座席指定搭乗者情報.id>.seatSelection.seatNumbers、
      // またはPNR情報取得API応答.data.seats.＜事前座席指定セグメント情報.id＞.<事前座席指定搭乗者情報.id>.seatSelection.characteristicRequestSsrCode)が存在する、
      (!isEmptyArray(seatSelection?.seatNumbers) || !isStringEmpty(seatSelection?.characteristicRequestSsrCode)) &&
      // かつPNR情報取得API応答.data.seats.＜当該事前座席指定セグメント情報.id＞.<当該事前座席指定搭乗者情報.id>.seatSelection.serviceStatus≠（""cancelled""(取り消し)かつ、""""(空欄）)の一つ要素が存在する·。
      !isStringEmpty(seatSelection?.serviceStatus) &&
      seatSelection?.serviceStatus !== OrderSeatItemSeatSelection.ServiceStatusEnum.Cancelled;
    // [1.2.1.3]
    // PNR情報取得API応答.data.seats.<当該セグメント情報.id>.<当該搭乗者情報.id>childSeat=true　かつ、
    // PNR情報取得API応答.data.seats.<当該セグメント情報.id>.<当該搭乗者情報.id>.seatSelection.serviceStatus ≠ ""cancelled""(削除)
    const condition2 = this._myBookingServiceService.checkHasChildSeat(seat);

    return condition1 || condition2;
  }

  /** [1.1.2] 事前座席指定情報 */
  /** [1.2] 事前座席指定情報 */
  get isDisplayAdvanceSeatReservationInfor(): boolean {
    let isShow = false;
    /** [1.2.1] 以下のいずれかに該当する場合、事前座席指定の申込状況を搭乗者(席なし幼児を除く)及びセグメント毎に表示する。*/
    if (
      /** [1.2.1.1] サービシング共通store.事前座席指定.申込操作中フラグ=true */
      this.seatReservationStatus?.isApplicationProcessed ||
      /**
       * [1.2.1.2]
       * [1.2.1.3]
       */
      this.isExistSeatServiceInPNR ||
      /**
       * [1.2.1.3] PNR情報取得API応答.data.orderEligibilities.seatmap.isEligibilityToForward = true
       */
      this.pnr?.orderEligibilities?.seatmap?.isEligibilityToForward
    ) {
      isShow = true;
    }

    /**
     * [1.2.2] 予約詳細store.チェックインサービス申込=true　または、　事前座席指定セグメント情報リスト=""""(空欄)の場合、当エリアを非表示とする。
     */
    if (this.isCheckInServiceApplication || isEmptyArray(this.seatFlightInforList)) {
      isShow = false;
    }
    return isShow;
  }

  /** [1.6] ラウンジ情報 */
  get isDisplayLoungeInfor(): boolean {
    // [1.6.1.1] サービシング共通store.ラウンジ情報.申込操作中フラグ=true
    // [1.6.1.2] PNR情報取得API応答.data.services.lounge.＜ラウンジセグメント情報.id＞.<ラウンジ搭乗者情報.id>.serviceStatus≠（""cancelled""(取り消し)かつ、""""(空欄）)の一つ要素が存在する。
    return this.chargeableLounge?.isApplicationProcessed || this.isExistLoungeService;
  }

  /** [1.7] 機内食情報 */
  get isDisplayInFlightMealInfor(): boolean {
    // [1.7.1] 機内食セグメント=""(空欄)の場合、当エリアを非表示とする。
    if (isEmptyArray(this.mealFlightInforList)) {
      return false;
    }
    // [1.7.2.1] サービシング共通store.機内食情報.申込操作中フラグ=true
    // [1.7.2.2] PNR情報取得API応答.data.services.mealが存在する　かつ、　PNR情報取得API応答.data.services.meal.＜当該機内食セグメント情報.id＞.<当該機内食搭乗者情報.id>.appliedMealListリストの中、id≠""(空欄の一つ要素が存在する。
    return this.meal?.isApplicationProcessed || this.isExistMealService;
  }

  // [1.8] ペットらくのり
  get isDisplayTravelWithPets(): boolean {
    // [1.8.1] PNR情報取得API応答.data.services.pet.＜ペットらくのりセグメント情報.id＞.<ペットらくのり搭乗者情報.id>.serviceStatus≠（""cancelled""(取り消し) かつ、""""(空欄）)の一つ要素が存在する場合、ペットらくのりの申込状況を搭乗者(席なし幼児を除く)及びセグメント毎に表示する。
    return this.isExistPetService;
  }

  /** [1.9] マイカーバレー情報 */
  get isDisplayMyCarValetInfor(): boolean {
    // [1.9.1] PNR情報取得API応答.data.services.myCarvalet.＜マイカーバレーセグメント情報.id＞.<マイカーバレー搭乗者情報.id>.isRequested=true(申込済)の一つ要素が存在する場合、マイカーバレーの申込状況を搭乗者(席なし幼児を除く)及びセグメント毎に表示する。
    return this.isExistMyCarValetService;
  }

  // [1.10] ジュニアパイロット情報
  get isDisplayJuniorPilot(): boolean {
    // [1.10.1] PNR情報取得API応答.data.services.juniorPilot.＜ジュニアパイロットセグメント情報.id＞.<ジュニアパイロット搭乗者情報.id>.serviceStatus=（""requested""(申込済)　または、""unnecessary""(不要の旨申込済み）)の一つ要素が存在する場合、搭乗者(席なし幼児を除く)及びセグメント毎に表示する。
    return this.isExistJuniorPilotService;
  }

  /** [1.11] アテンド情報 */
  get isDisplayAttendanceInfor(): boolean {
    return (
      isEmptyObject(this.pnr?.services?.airportService) !== true && isEmptyArray(this.attendFlightInforList) !== true
    );
  }

  // [1.12] 配慮系サポート情報
  get isDisplaySupport(): boolean {
    // [1.12.1] PNR情報取得API応答.data.services.serviceSupport.<配慮系サポート搭乗者情報.id>.serviceStatus≠(""cancelled""(承れなかった)かつ、""""(空欄）)の一つ要素が存在する場合、搭乗者(席なし幼児を除く)及びセグメント毎に表示する。
    return this.isExistSupportService;
  }

  // [1.13] 申込確定ボタンエリア
  get isDisplayMyBookingServicesFooter(): boolean {
    return this._myBookingServiceService.onHandleCommonNo2();
  }

  // [1.14] 旅程操作メニュー
  get isDisplayItineraryOperationMenu(): boolean {
    return (
      // 1.1. 予約詳細画面(S01-P030)で保持しているチェックインサービス申込=false
      this.isCheckInServiceApplication !== true &&
      // 1.2.ユーザ共通情報.端末種別=PC
      this._common.aswContextStoreService.aswContextData?.deviceType === DeviceType.PC
    );
  }

  // [1.15] ANA新規入会
  get isDisplayNewANAMembership(): boolean {
    return this._myBookingStoreService.myBooking.checkInServiceApplication !== true;
  }

  // [1.17] レコメンド
  get isDisplayRecommend(): boolean {
    return this._common.aswContextStoreService.aswContextData?.deviceType === DeviceType.PC;
  }

  onHandleDisplayPet(flight?: Type1, traveler?: Traveler): boolean {
    const pet = this.pnr?.services?.pet?.registeredPets as PetService;
    const registeredPet =
      (pet?.[String(flight?.id)]?.[String(traveler?.id)] as Array<PassengerRegisteredPetsMap>) ??
      ([] as Array<PassengerRegisteredPetsMap>);
    return (
      Array.isArray(registeredPet) &&
      isEmptyArray(registeredPet) !== true &&
      registeredPet.some(
        (pet) =>
          isStringEmpty(pet.serviceStatus) !== true &&
          pet.serviceStatus !== PassengerRegisteredPetsMap.RegisteredPetStatusEnum.Cancelled
      )
    );
  }

  onHandleDisplayMeal(): boolean {
    // PNR情報取得API応答.data.services.mealが存在する　かつ、　PNR情報取得API応答.data.services.meal.＜当該機内食セグメント情報.id＞.<当該機内食搭乗者情報.id>.appliedMealListリストの中、id≠""(空欄）の一つ要素が存在する。
    return this.flights?.some((flight) => {
      return parseEmptyArray(this.pnr?.travelers).some((traveler) => {
        const meal = this.pnr?.services?.meal as Meal;
        const travelerMealInfo = meal?.[String(flight?.id)]?.[String(traveler.id)] as TravelerMealInfo;
        return (
          isEmptyObject(travelerMealInfo) !== true &&
          travelerMealInfo.appliedMealList.some(
            (meal) => meal?.serviceStatus !== TravelerMealInfo.ServiceStatusEnum.Cancelled
          )
        );
      });
    });
  }

  isMyCarValetDomestic(): boolean {
    // ユーザ共通情報.posCountryCode="JP"(日本)、かつ 以下の全ての条件を満たす場合、表示する
    const posCountryCodeJP = this._common.aswContextStoreService.aswContextData?.posCountryCode === POS_COUNTRY_CODE_JP;

    // [2.20.1] PNR情報取得API応答.data.air.tripType = "domestic"(日本国内単独旅程)
    const isDomestic = this.pnr?.air?.tripType === GetOrderResponseDataAir.TripTypeEnum.Domestic;

    // [2.20.2] サービスを申し込むPNR、または当該セグメント情報の中に、  departure.locationcodeまたは
    // arrival.locationcode = "NGO"が存在する。
    const hasLocationNgo = parseEmptyArray(this.flights).some(
      (flight) =>
        flight?.arrival?.locationCode === LOCATION_CODOE_NGO || flight?.departure?.locationCode === LOCATION_CODOE_NGO
    );

    /**
     * [2.20.3] PNR情報取得API応答.data.orderEligibilities.flightReaccomodation.acknowledge.isEligible = false、
     * またはPNR情報取得API応答.data.nextActions.acknowledgeOrSelfReaccommodationが存在しない
     */
    const acknowledge =
      this.pnr?.orderEligibilities?.flightReaccommodation?.acknowledge?.isEligible === false ||
      this.pnr?.nextActions?.acknowledgeOrSelfReaccommodation !== true;

    /**
     * [2.20.4] PNR情報取得API応答.data.air.bounds[].flights[]の件数分二重繰り返し、(ぞれの要素が当該セグメント情報）
     * 当該セグメント情報.statusCode≠”UN”　かつ、
     * 当該セグメント情報.departure.dateTime＞システム日時(サービスを申し込むPNRが過去PNRではない)
     */
    const currentDateTimeMilisecond = this._systemDateSvc.getSystemDate().getTime();
    const isDepartureDateTime = parseEmptyArray(this.flightsByUN).some((flight) => {
      const dateTimeFlight = new Date(flight?.departure?.dateTime ?? '').getTime();
      return dateTimeFlight > currentDateTimeMilisecond;
    });

    // 5.ユーザ共通.言語情報 = "JA"
    const langJP = this._common.aswContextStoreService.aswContextData?.lang === LANGUAGE_JP;

    return posCountryCodeJP && isDomestic && hasLocationNgo && acknowledge && isDepartureDateTime && langJP;
  }

  isMyCarValetInternational(): boolean {
    return (
      Boolean(this.pnr?.orderEligibilities?.myCarValet?.isEligibleToForward) &&
      this.pnr?.air?.tripType === GetOrderResponseDataAir.TripTypeEnum.International
    );
  }

  ngAfterViewChecked(): void {
    this.isTheLastViewChecked$.next(true);
  }

  override reload(): void {
    /* override abstract reload function of base class */
  }

  destroy(): void {
    if (this._subscriptions) {
      this._subscriptions.unsubscribe();
    }
  }
}
